import type { ProblemTemplate } from '../../types.ts';
import { GRADE_01 } from './grade01.ts';
import { GRADE_02 } from './grade02.ts';
import { GRADE_03 } from './grade03.ts';
import { GRADE_04 } from './grade04.ts';
import { GRADE_05 } from './grade05.ts';
import { GRADE_06 } from './grade06.ts';
import { GRADE_07 } from './grade07.ts';
import { GRADE_08 } from './grade08.ts';
import { GRADE_09 } from './grade09.ts';
import { GRADE_10 } from './grade10.ts';
import { GRADE_11 } from './grade11.ts';
import { GRADE_12 } from './grade12.ts';

export const ALL_TEMPLATES: ProblemTemplate[] = [
  ...GRADE_01, ...GRADE_02, ...GRADE_03, ...GRADE_04, ...GRADE_05, ...GRADE_06,
  ...GRADE_07, ...GRADE_08, ...GRADE_09, ...GRADE_10, ...GRADE_11, ...GRADE_12,
];
